import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@contexts/LanguageContext';
import { BaseModal } from '@components/modals';
import { Button } from '@components/common';
import api from '@services/api';
import './BorrowingActions.scss';


export const BorrowingActions = ({ borrowing, permissions = {} }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [modalState, setModalState] = useState({ isOpen: false, mode: 'delete' });


    if (!borrowing) {
        return null;
    }

    const isReturned = !!borrowing.returned_at;
    const isBorrowed = !!borrowing.borrowed_at;
    const isActualReservation = borrowing.status == 'reservation_active';
    const isFutureReservation = borrowing.status == 'reserved';
    const isPendingValidation = borrowing.status === 'pending_validation';
    const isRejected = borrowing.status === 'validation_rejected';
    const isEditableReservation = isFutureReservation || isPendingValidation || isRejected;

    const handleModalClose = () => {
        setModalState({ isOpen: false, mode: 'delete' });
    };

    const handleModalSuccess = () => {
        navigate('/borrowings');
    };

    const handleReturnResource = () => {
        navigate(`/borrowings/${borrowing.id}/return`);
    };

    const handleBorrowResourceReservation = () => {
        navigate(`/borrowings/${borrowing.id}/borrow`);
    };

    const handleEditReservation = () => {
        navigate(`/borrowings/${borrowing.id}/edit`);
    };

    const handleDeleteReservation = () => {
        setModalState({ isOpen: true, mode: 'delete' });
    };

    return (
        <div className="borrowing-actions">
            {/* Bouton Retourner - affiché seulement si emprunté et pas encore retourné */}
            {!isReturned && isBorrowed && permissions.canReturn && (
                <Button
                    variant="return"
                    onClick={handleReturnResource}
                >
                    {t('borrowingView.returnResource')}
                </Button>
            )}

            {/* Bouton Emprunter - affiché seulement si c'est une réservation et on peut emprunter */}
            {isActualReservation && !isBorrowed && permissions.canUpdate && (
                <Button
                    variant="borrow"
                    onClick={handleBorrowResourceReservation}
                >
                    {t('borrowingView.startReservation')}
                </Button>
            )}

            {isEditableReservation && permissions.canUpdate && (
                <Button
                    variant="reserve"
                    onClick={handleEditReservation}
                >
                    {t('borrowingView.editReservation')}
                </Button>
            )}

            {isEditableReservation && permissions.canUpdate && (
                <Button
                    variant="danger"
                    onClick={handleDeleteReservation}
                >
                    {t('borrowingView.deleteReservation')}
                </Button>
            )}

            <BaseModal
                isOpen={modalState.isOpen}
                onClose={handleModalClose}
                onSuccess={handleModalSuccess}
                mode={modalState.mode}
                item={{
                    ...borrowing,
                    name: borrowing.resource?.name
                        ? `${borrowing.resource.name} (${borrowing.user?.name || borrowing.user?.email || 'User'})`
                        : `Borrowing #${borrowing.id}`
                }}
                itemType="borrowing"
                deleteFn={async (id) => await api.delete(`/borrowings/${id}`)}
                size="small"
                translations={{
                    deleteTitle: 'borrowings.admin.deleteTitle',
                    deleteConfirmation: borrowing.borrowed_at ? 'borrowings.admin.deleteConfirmation' : 'borrowings.admin.reservationDeleteConfirmation',
                    deleteSuccess: 'borrowings.admin.deleteSuccess',
                    deleteError: 'borrowings.admin.deleteError'
                }}
            />

        </div>
    );
};
